const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const codeGeneration = require('../codeGeneration');

let setupCode = '';
let loopCode = '';
let defineCode = '';
let bodycode = '';
let codeContext = 'setup';
const definedFunctions = new Set();
const definedServos = new Set(); // Keep track of defined servos
class Scratch3HumanoidRobotBlocks {
  constructor(runtime) {
    this.runtime = runtime;
    codeContext = localStorage.getItem('codeContext');
  }
  getInfo() {
    return {
      id: 'humanoidrobot',
      color1: '#3287a8',
      name: formatMessage({
        id: 'humanoidrobot.categoryName',
        default: 'Humanoid Robot',
        description: 'Extension to control Humanoid Robot based on Arduino.'
      }),
      blocks: [
        {
          opcode: 'connectrobo',
          blockType: BlockType.COMMAND,
          text: formatMessage({
            id: 'humanoidrobot.connectrobo',
            default: 'Connect to Humanoid Robot',
            description: 'Connect to the Humanoid Robot.'
          }),
        },
      ],
      menus: {
      }
    };
  }
  resetCode() {
    // Reset all accumulated code and status
    setupCode = '';
    loopCode = '';
    defineCode = '';
    bodycode = '';
  }
  full_reset() {
    setupCode = '';
    loopCode = '';
    defineCode = '';
    bodycode = '';
    definedServos.clear(); // Clear the set of defined servos
    definedFunctions.clear();
    console.log('Arm Code has been reset.');
  }

  accumulateCode() {
    codeGeneration.accumulateCode(defineCode, bodycode, setupCode, loopCode);
  }
    connectrobo(args, util) {
       console.log('Connecting to Humanoid Robot...');
    }
  
}
module.exports = Scratch3HumanoidRobotBlocks;
